// tslint:disable-next-line import-blacklist
import Raven, { RavenOptions } from 'raven-js';

let inited = false;

function getLoadedScripts(): string[] {
    const scripts = Array.from(document.querySelectorAll('script'));

    return scripts.map(el => el.getAttribute('src')).filter(el => el) as string[];
}

function initRaven(): void {
    const sentryURI = 'https://3fe854451c7b43f9a7fc446e45a9e960@sentry.iddqd.yandex.net/234';

    Raven.config(sentryURI).install();
}

function initRumErrorCounter(): void {
    // все остальное для счетчика инициализируется в старом интерфейсе
    // error-counter-debug для локальной отладки error-counter нужно раскомментировать строки в service/RUM/Rum.ts
    Ya.Rum.updateErrors({
        transform: function(error: Ya.Rum.NormalizedError): Ya.Rum.TransformedError {
            return {
                ...error,
                additional: {
                    scripts: getLoadedScripts()
                }
            };
        }
    });
}

export function initErrorsReporting(isDevelopmentEnv: boolean = true): boolean {
    // error-counter-debug для локальной отладки счетчика убрать условие
    if (!inited && isDevelopmentEnv) {
        return false;
    }

    if (!inited) {
        initRumErrorCounter();
        initRaven();

        inited = true;
    }

    return inited;
}

const dnaErrorType = 'dnaErrorType';

export type AppError = Error | ErrorEvent;

export enum AppErrorType {
    componentLazyLoadError = 'componentLazyLoadError',
    chunkError = 'chunkError',
    PCodeError = 'PCodeError',
    creativePreviewError = 'creativePreviewError',
    videoCreatorPreviewError = 'videoCreatorPreviewError'
}

export function captureException(error: AppError | string, params: { extra?: object; type?: AppErrorType } = {}): void {
    if (!initErrorsReporting()) {
        return;
    }

    const err: AppError = typeof error === 'string' ? new Error(error) : error;

    const { extra, type } = params;

    const rumExtra: Ya.Rum.LogErrorOptions = {
        additional: extra
    };

    const ravenExtra: RavenOptions = {
        extra: {
            pageScripts: getLoadedScripts(),
            ...extra
        }
    };

    if (type !== undefined) {
        rumExtra.type = type;
        ravenExtra.tags = {
            [dnaErrorType]: type
        };
    }

    if (window.Ya && Ya.Rum && Ya.Rum.logError) {
        Ya.Rum.logError(rumExtra, err);
    }
    Raven.captureException(err, ravenExtra);
}

export function captureComponentLazyLoadError(error: AppError, errorInfo: React.ErrorInfo): void {
    return captureException(error, {
        extra: { errorInfo },
        type: AppErrorType.componentLazyLoadError
    });
}

export function captureChunkLoadException(error: AppError, chunkName: string): void {
    return captureException(error, {
        extra: { chunkName },
        type: AppErrorType.chunkError
    });
}

export function capturePCodeError(error: AppError): void {
    return captureException(error, {
        type: AppErrorType.PCodeError
    });
}
